import Config from '../../common/config/config';


export default class BookData{


    constructor(data){
        this.data = data;
        this._init();
    }


    get _allData(){
        return this.data();
    }

    get _bookFile(){
        return `${this.BOOK_PATH + this.data['会社識別子'] + this.data['コンテンツID']}.jpg`;
    }

    get _title(){
        return this.data['タイトル'];
    }

    get _usrDatas(){
        return this.USER_DATAS;
    }

    get _tags(){
        return this.TAGS;
    }

    get _link(){
        return `/member/nm/ShowContents?contentsCd=${this.data['会社識別子'] + this.data['コンテンツID']}`; 
    }

    get _author(){
        return this.data['作者'];
    }

    get _publish(){
        return this.data['出版社'];
    }

    get _excerpt(){
        return this.data['コンテンツ説明文'];
    }
    
    get _bindData(){
        return {title:this._title, bookfile:this._bookFile, tags:this._tags, link:this._link, author:this._author, publish:this._publish, excerpt:this._excerpt};
    }


    _init(){
        this.BOOK_PATH = `${Config.image_dir}top/books/`;
        this.USER_DATAS = this._setUsrData();
        this.TAGS = this._setTags();
    }


    _setTags(){
        this.TAGS = [];

        for(let i=1; i<=5; i++){
            const tag = this.data[`タグ${i}`];
            if(tag != '') this.TAGS.push(tag);
        }

        return this.TAGS;
    }

    _setUsrData(){
        this.USER_DATAS = [];
        
        for(let i=1; i<=5; i++){
            const grade = this.data[`学年${i}`];
            const name = this.data[`ペンネーム${i}`];
            const kanso = this.data[`感想${i}`];

            if(kanso != ''){
                this.USER_DATAS.push({'学年':grade, 'ペンネーム':name, '感想':kanso});
            }
        }

        return this.USER_DATAS;
    }
}
